module.exports = __webpack_public_path__ + "static/media/whitebin.f615abcd.svg";